export default {
  yourSkills: "Vos compétences",
  skills: "Compétences",
  skill: "Compétence",
  last_skill_update: "Dernier enregistrement",
  duration: "Durée",
  Category: "Categorie",
  "Skills saved successfully": "Compétences enregistrées avec succès",
  next: "Suivante",
  previous: "Précédente",
  seeHistoric: "Afficher l'historique",
  resetSkill: "Réinitialiser la compétence",
  justificativePieceSend: "Pièce justificatives envoyées",
  sendJustificativePiece: "Envoyer des pièces justificatives",
  impossibleJustificativeSending: "Ajout de pièces jsutificatives possible après la notation",
  stats: {
    no_data: "Aucune donnée encore saisie",
  },
  no_skills: "Aucune compétence n'est renseignée pour cette catégorie",
  no_skill_available: "Aucune compétence n'est renseignée pour le moment",
  no_skill_complete: "Aucune compétence n'a été complétée",
  skill_chart: "Graphique des compétences",
  skill_chart_pdf_name: "graphique-des-compétences",
  referential_visible: ({ plural }) => plural(["Référentiel actif", "Référentiel inactif"]),
  session_visible: ({ plural }) => plural(["Session active", "Session inactive"]),
  generate_all_rncp_referential: "Générer tous les référentiels France Compétences",
  empty_config: "Attention la configuration du module compétences n'est pas finalisée",
  admin_config: {
    enable_on_all_training_course: {
      title: "Utiliser la configuration Admin sur toutes les promotions actives",
      confirm: {
        title: "Utiliser la configuration admin ?",
        subtitle:
          "Attention cela affectera la configuration admin à toutes les promotions actives, même celles qui utilisent une configuration personalisée",
      },
    },
    disable_on_all_training_course: {
      title: "Utiliser la configuration personnalisée sur toutes promotions actives",
      confirm: {
        title: "Utiliser la configuration personnalisée ?",
        subtitle:
          "Attention cela affectera la configuration personnalisée sur toutes les promotions actives, même celles qui utilisent la configuration admin",
      },
    },
  },
  skill_admin_config_in_use: "Vous utiliser actuellement la configuration admin pour les périodes.",
  notEvaluable: "Non évaluable",
  gradingScale: "Barème de notation",
};
